import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { euro, formatApiErrorDetail } from "@/lib/format";
import { fmtDay } from "@/lib/cantieri";

const OPZIONI = [["anticipo", "Anticipo"], ["rimborso", "Rimborso"], ["", "Lascia in Spese"]];

// Spese di gestione che contengono il nome di un operaio: per ognuna scegli se spostarla sulla sua scheda.
export const SpeseOperaiDialog = ({ items, onClose, onDone }) => {
  const [scelte, setScelte] = useState({});
  const [busy, setBusy] = useState(false);
  const chosen = items.filter((x) => x.expense.id in scelte);
  const moving = chosen.filter((x) => scelte[x.expense.id]).length;
  const move = async () => {
    setBusy(true);
    try {
      const r = await api.post("/operai/trasferisci-spese", { items: chosen.map((x) => ({ expense_id: x.expense.id, operaio_id: x.operaio_id, tipo: scelte[x.expense.id] || "lascia" })) });
      toast.success(r.data.spostate ? `${r.data.spostate} ${r.data.spostate === 1 ? "spesa spostata" : "spese spostate"} sulle schede degli operai` : "Scelte salvate: le spese restano in Spese di gestione");
      onDone();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="spese-operai-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Spese degli operai trovate in Spese di gestione</DialogTitle>
          <DialogDescription>Scegli per ognuna: le spese spostate escono da Spese di gestione e vengono contate una volta sola, sulla scheda dell'operaio.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {items.map(({ expense: e, operaio_nome: n }) => (
            <div key={e.id} className="rounded-xl border border-border p-3 space-y-2" data-testid={`spesa-operaio-${e.id}`}>
              <div className="flex items-start gap-3 text-sm">
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate">{e.descrizione || e.categoria}</div>
                  <div className="text-xs text-muted-foreground truncate">{[fmtDay(e.data), e.fornitore, e.categoria].filter(Boolean).join(" · ")}</div>
                  <div className="text-xs mt-0.5">Operaio: <b>{n}</b></div>
                </div>
                <div className="font-semibold tabular-nums">{euro(e.importo)}</div>
              </div>
              <div className="grid grid-cols-3 gap-1.5">
                {OPZIONI.map(([k, l]) => (
                  <button key={l} type="button" onClick={() => setScelte((s) => ({ ...s, [e.id]: k }))} data-testid={`spesa-operaio-${e.id}-${k || "lascia"}`}
                    className={`min-h-[44px] rounded-lg border text-sm font-medium transition-colors ${(scelte[e.id] ?? null) === k && (k || e.id in scelte) ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-secondary"}`}>{l}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Chiudi</Button>
          <Button onClick={move} disabled={busy || !chosen.length} data-testid="spese-operai-move-button">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : moving ? `Sposta ${moving} ${moving === 1 ? "spesa" : "spese"}` : "Salva scelte"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SpeseOperaiDialog;
